import { faArrowUp } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders an up arrow icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/arrow-up?f=classic&s=solid
 */
export const ArrowUpIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faArrowUp} {...props} />;
};
